import { render, staticRenderFns } from "./OrganizationPeerGroupGuard.vue?vue&type=template&id=7cfe00c8&"
import script from "./OrganizationPeerGroupGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports